import script from "./FlightBannerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./FlightBannerComp.vue?vue&type=script&setup=true&lang=js"

import "./FlightBannerComp.vue?vue&type=style&index=0&id=981eeda8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-981eeda8"]])

export default __exports__